import i18n from '@/vue-app/plugins/i18n';

export default class SuccessfulAllianzProcessViewModel {
  private readonly i18n_namespace = 'components.contract-savings.allianz.successful-allianz-process';

  translate = (value: string) => (
    i18n.t(`${this.i18n_namespace}.${value}`) as string
  )
}
